// Client-side port of backend/routes/prices.js — runs against the static
// deals.json snapshot since item names are typed live and can't be precomputed.
const TARGET_STORES = ['Coles', 'Woolworths', 'Aldi'];

function normalize(name) {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, ' ')
    .replace(/\b\d+\.?\d*\s*(g|kg|ml|l|mg|mcg|iu|pk|pkt|pack|x\s*\d*|ct|pieces?|serves?|tablets?|capsules?|sachets?|sheets?|wipes?)\b/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function jaccard(a, b) {
  const setA = new Set(a.split(' ').filter(w => w.length > 2));
  const setB = new Set(b.split(' ').filter(w => w.length > 2));
  if (!setA.size || !setB.size) return 0;
  const inter = [...setA].filter(w => setB.has(w)).length;
  const union = new Set([...setA, ...setB]).size;
  return inter / union;
}

function matchItem(itemName, deals) {
  const normItem = normalize(itemName);
  const result = {};

  for (const store of TARGET_STORES) {
    const storeDeals = deals.filter(d => d.store === store);
    let bestScore = 0;
    let bestDeal  = null;

    for (const deal of storeDeals) {
      const score = jaccard(normItem, normalize(deal.name));
      if (score > bestScore) { bestScore = score; bestDeal = deal; }
    }

    if (bestScore >= 0.35 && bestDeal) {
      result[store] = {
        price:         bestDeal.salePrice,
        originalPrice: bestDeal.originalPrice || null,
        discount:      bestDeal.discount || null,
        productName:   bestDeal.name,
        url:           bestDeal.url || null,
        score:         Math.round(bestScore * 100),
      };
    } else {
      result[store] = null;
    }
  }

  return result;
}

// Mirrors GET /api/prices?items=a,b,c — { [itemName]: { Coles, Woolworths, Aldi } }
export function matchPrices(itemNames, deals) {
  const result = {};
  for (const name of itemNames) {
    result[name] = matchItem(name, deals);
  }
  return result;
}
